import { IMessage } from '../interfaces';
import axiosInstance from './axiosConfig';

export interface ApiResponse<T> {
  status: boolean;
  meta?: unknown;
  result: T;
}

export const sendMessage = (message: IMessage) =>
  axiosInstance.post<ApiResponse<IMessage>>('/messages', message);

export const fetchMessages = (
  receiverId: string,
  options: { unreadOnly?: boolean; afterDate?: Date } = {}
) => {
  const params: Record<string, boolean | string> = {};

  if (options.unreadOnly) {
    params.unreadOnly = true;
  }
  if (options.afterDate) {
    params.afterDate = options.afterDate.toISOString();
  }

  return axiosInstance.get<ApiResponse<IMessage[]>>(`/messages/${receiverId}`, {
    params,
  });
};
